import React, { useState, useEffect } from 'react';
import { Card, CardTitle, Insight } from '../components/UI';
import { supabase } from '../supabaseClient';
const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
function useIsMobile() {
  const [m,setM]=React.useState(()=>typeof window!=='undefined'&&window.innerWidth<768);
  React.useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);
  return m;
}
const TYPES = {
  ticket:    { color:'#314F5C', label:'Support ticket', bg:'#E6F1FB' },
  geocoding: { color:'#fd7e14', label:'Geocoding',      bg:'#FAEEDA' },
  sana_l3:   { color:'#dc3545', label:'Sana L3 failure',bg:'#FCEBEB' },
  system:    { color:'#28a745', label:'System',          bg:'#E1F5EE' },
  data:      { color:'#9F7E4F', label:'Data issue',      bg:'#F1EFE8' },
};
export default function NotificationsCentre() {
  const isMobile = useIsMobile();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('sanoire_dismissed_notifs')||'[]'); } catch { return []; }
  });

  useEffect(() => {
    (async () => {
      const built = [];
      try {
        // Open tickets
        const {count:openTickets} = await supabase.from('support_tickets').select('*',{count:'exact',head:true}).eq('status','open');
        if (openTickets>0) built.push({id:'tickets',type:'ticket',title:`${openTickets} open support ticket${openTickets>1?'s':''}`,desc:'Waiting for response',action:'customerhelp',actionLabel:'→ Customer Help',ts:Date.now()});
        // Sana L3 queries today
        const today = new Date().toISOString().slice(0,10);
        const {count:l3Today} = await supabase.from('sana_invocations').select('*',{count:'exact',head:true}).eq('fallback_level',3).gte('created_at',today+'T00:00:00Z');
        if (l3Today>0) built.push({id:'sana_l3_today',type:'sana_l3',title:`${l3Today} L3 failures today`,desc:'Queries that returned zero results — check Sana & Search',action:'sana',actionLabel:'→ Sana & Search',ts:Date.now()});
        // Data quality
        const {count:missing} = await supabase.from('Locations').select('*',{count:'exact',head:true}).is('latitude',null);
        if (missing>50000) built.push({id:'geocoding_gap',type:'geocoding',title:`${missing.toLocaleString()} locations missing GPS`,desc:'Near-me search returns L3 for these locations',action:'geocoding',actionLabel:'→ Geocoding',ts:Date.now()});
        // Never verified
        const {count:never} = await supabase.from('Locations').select('*',{count:'exact',head:true}).is('last_verified',null);
        if (never>10000) built.push({id:'never_verified',type:'data',title:`${never.toLocaleString()} locations never verified`,desc:'Data quality risk — assign to verify queue',action:'verifyqueue',actionLabel:'→ Verify queue',ts:Date.now()});
        // System: all green placeholder
        built.push({id:'system_ok',type:'system',title:'System status: all green',desc:'Vercel · Supabase · Sana AI · Open-Meteo all operational',action:'system',actionLabel:'→ System',ts:Date.now()});
      } catch (_e) {}
      setItems(built);
      setLoading(false);
    })();
  }, []);

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    localStorage.setItem('sanoire_dismissed_notifs', JSON.stringify(next));
  };

  const visible = items.filter(i => !dismissed.includes(i.id));
  const hidden  = items.filter(i =>  dismissed.includes(i.id));

  return (
    <div style={{fontFamily:F,padding:isMobile?'16px 14px 80px':'24px 28px'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:20}}>
        <div>
          <h2 style={{fontSize:'1.1rem',fontWeight:500,margin:0,color:'var(--color-text-primary)'}}>Notifications</h2>
          <p style={{fontSize:'.78rem',color:'var(--color-text-secondary)',margin:'4px 0 0'}}>System alerts, data issues, and support queue in one place.</p>
        </div>
        {dismissed.length>0&&<button onClick={()=>{setDismissed([]);localStorage.removeItem('sanoire_dismissed_notifs');}} style={{fontSize:'.7rem',color:'#6F8FA7',background:'none',border:'1px solid var(--color-border-secondary)',borderRadius:6,padding:'4px 10px',cursor:'pointer',fontFamily:F}}>Restore {dismissed.length} dismissed</button>}
      </div>
      {loading&&<div style={{color:'var(--color-text-secondary)',fontSize:'.78rem',padding:'20px 0'}}>Loading…</div>}
      {!loading&&visible.length===0&&<Insight type="ok">All clear — no active notifications.</Insight>}
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        {visible.map(item => {
          const t = TYPES[item.type]||TYPES.data;
          return (
            <Card key={item.id} style={{padding:'12px 16px',borderLeft:`3px solid ${t.color}`,borderRadius:'0 8px 8px 0'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:12}}>
                <div style={{flex:1}}>
                  <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:3}}>
                    <span style={{fontSize:'.6rem',fontWeight:500,padding:'1px 7px',borderRadius:8,background:t.bg,color:t.color}}>{t.label}</span>
                  </div>
                  <div style={{fontSize:'.82rem',fontWeight:500,color:'var(--color-text-primary)',marginBottom:2}}>{item.title}</div>
                  <div style={{fontSize:'.72rem',color:'var(--color-text-secondary)'}}>{item.desc}</div>
                </div>
                <div style={{display:'flex',gap:6,flexShrink:0,alignItems:'center'}}>
                  <button onClick={()=>dismiss(item.id)} style={{fontSize:'.65rem',color:'var(--color-text-secondary)',background:'none',border:'1px solid var(--color-border-secondary)',borderRadius:5,padding:'3px 8px',cursor:'pointer',fontFamily:F}}>Dismiss</button>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
      {hidden.length>0&&(
        <div style={{marginTop:20,fontSize:'.72rem',color:'var(--color-text-secondary)'}}>
          {hidden.length} notification{hidden.length>1?'s':''} dismissed
        </div>
      )}
    </div>
  );
}
